import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const GlobalStyle = createGlobalStyle`
  ${normalize}

  h1 {
    margin: 0;
  }

  body {
    font-family: 'Overpass', sans-serif;
  }
`;

export default GlobalStyle;
